import { getPercentage } from './getPercentage';

export const getProfitabilityTableRows = (data) => {
	return data.map((row, idx) => (
		<tr key={idx}>
			<td>{row.consultant.contractType}</td>
			<td>{row.consultant.displayName}</td>
			<td>{`${row.bonus.toFixed(2)} ${row.consultant.currency ?? '---'}`}</td>
			<td>{`${row.base.toFixed(2)} ${row.consultant.currency ?? '---'}`}</td>
			<td>{getPercentage(row.profitability)}</td>
		</tr>
	));
};
